<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <h1>{{ this.form.titulo }}</h1>
        <b-row>
          <b-col cols="12">
            <div v-html="this.form.descricao"></div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card no-body class="mx-4" v-for="artigo in form.artigos" :key="artigo.id">
      <b-card-body class="p-12">
        <b-row>
          <b-col cols="12">
            <div v-html="artigo.texto"></div>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="4">
            <b-button block variant="secondary"  @click="loadModalSugestaoEdicao(artigo.id)">
              <i class="fa fa-pencil"></i>&nbsp;
              <span>Visualizar Sugestão de Edição</span>
              <span class="badge badge-light">{{ artigo.totalSugestoesAlteracao }}</span>
            </b-button>
          </b-col>
          <b-col md="4">
            <b-button block variant="secondary" @click="loadModalSugestaoExclusao(artigo.id)">
              <i class="fa fa-trash"></i>&nbsp;
              <span>Visualizar Sugestão de Exclusão</span>
              <span class="badge badge-light">{{ artigo.totalSugestoesExclusao }}</span>
            </b-button>
          </b-col>
           <b-col md="4">
            <b-button block variant="secondary" @click="loadModalComentarios(artigo.id)">
              <i class="fa fa-comments"></i>&nbsp;
              <span>Visualizar Comentários</span>
              <span class="badge badge-light">{{ artigo.totalComentarios }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
    <b-card no-body class="mx-4">
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="3">
            <b-button block variant="secondary" @click="navigate('/regimento')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>

    <b-modal title="Visualizar Comentários" size="lg" ok-title="Exportar" cancel-title="Cancelar" v-model="modalComentario">
      <b-card-body>
        <b-form v-if="comentarios.data">
          <b-row v-for="comentario in comentarios.data" :key="comentario.id">
            <b-col md="12" sm="12">
              <b-card no-body>
                <b-card-body class="p-12">
                  <b-row>
                    <b-col cols="9">
                      <strong>Usuário: </strong> {{ comentario.nome_social ? comentario.nome_social : comentario.usuario }} / {{ comentario.uf }}
                    </b-col>
                    <b-col cols="3">
                      <i>{{ comentario.created_at }}</i>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <div v-html="comentario.texto"></div>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <pagination v-show="this.comentarios.data.length > 0" :totalPorPagina="5" :resource="resourceComentario"></pagination>
        </b-form>
      </b-card-body>
    </b-modal>

    <b-modal title="Visualizar Sugestões de Edição" size="lg" ok-title="Exportar" cancel-title="Cancelar" v-model="modalSugestaoEdicao">
      <b-card-body>
        <b-form v-if="this.edicoes.data">
          <b-row v-for="edicao in edicoes.data"  :key="edicao.id">
            <b-col md="12" sm="12">
              <b-card no-body>
                <b-card-body class="p-12">
                  <b-row>
                    <b-col cols="9">
                      <strong>Usuário: </strong>  {{ edicao.nome_social ? edicao.nome_social : edicao.usuario }} / {{ edicao.uf }}
                    </b-col>
                    <b-col cols="3">
                      <i>{{ edicao.created_at }}</i>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="4">
                      <strong>Texto Atual</strong>
                    </b-col>
                    <b-col cols="8">
                      <div v-html="edicao.texto_atual"></div>
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 10px">
                    <b-col cols="4">
                      <strong>Sugestão de Alteração</strong>
                    </b-col>
                    <b-col cols="8">
                      <div v-html="edicao.texto_sugerido"></div>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <pagination v-show="this.edicoes.data.length > 0" :totalPorPagina="5" :resource="resourceSugestao" :filtros="filtros"></pagination>
        </b-form>
      </b-card-body>
    </b-modal>

    <b-modal title="Visualizar Sugestões de Exclusão" size="lg" ok-title="Exportar" cancel-title="Cancelar" v-model="modalSugestaoExclusao">
      <b-card-body>
        <b-form v-if="exclusoes.data">
          <b-row v-for="exclusao in exclusoes.data" :key="exclusao.id">
            <b-col md="12" sm="12">
              <b-card no-body>
                <b-card-body class="p-12">
                  <b-row>
                    <b-col cols="9">
                      <strong>Usuário: </strong>  {{ exclusao.nome_social ? exclusao.nome_social : exclusao.usuario }} / {{ exclusao.uf }}
                    </b-col>
                    <b-col cols="3">
                      <i>{{ exclusao.created_at }}</i>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="4">
                      <strong>Texto Atual</strong>
                    </b-col>
                    <b-col cols="8">
                      <div v-html="exclusao.texto_atual"></div>
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 10px">
                    <b-col cols="4">
                      <strong>Sugestão de Alteração</strong>
                    </b-col>
                    <b-col cols="8">
                      <div v-html="exclusao.texto_sugerido"></div>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <pagination v-show="this.exclusoes.data.length > 0" :totalPorPagina="5" :resource="resourceSugestao"  :filtros="filtros"></pagination>
        </b-form>
      </b-card-body>
    </b-modal>
  </b-col>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    Pagination,
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      descricao: {
        required
      }
    }
  },
  created () {
    if (!this.can('regimento.show')) {
      this.$router.push('/')
    }
    this.loadRegimento(this.$route.params.id)
  },
  data () {
    return {
      loading: false,
      form: {
        titulo: '',
        descricao: '',
        artigos: []
      },
      filtros: {
        tipo: null
      },
      resourceSugestao: '',
      resourceComentario: '',
      modalSugestaoEdicao: false,
      modalSugestaoExclusao: false,
      modalComentario: false,
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false
    }
  },
  watch: {
    'filtros.tipo': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resourceSugestao, limit: 5, filtros: this.filtros})
      this.setarFiltros(this.filtros)
    }
  },
  computed: {
    edicoes () {
      return this.$store.state.pagination.getList
    },
    exclusoes () {
      return this.$store.state.pagination.getList
    },
    comentarios () {
      return this.$store.state.pagination.getList
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  methods: {
    loadModalSugestaoEdicao (artigo) {
      this.resourceSugestao = 'regimento/' + artigo + '/sugestao'
      this.modalSugestaoEdicao = true
      this.filtros.tipo = 'A'
    },
    loadModalSugestaoExclusao (artigo) {
      this.resourceSugestao = 'regimento/' + artigo + '/sugestao'
      this.modalSugestaoExclusao = true
      this.filtros.tipo = 'E'
    },
    loadModalComentarios (artigo) {
      this.resourceComentario = 'regimento/' + artigo + '/comentario'
      this.modalComentario = true
      this.$store.dispatch('getRegistrosSearch', {resource: this.resourceComentario, limit: 5})
    },
    loadRegimento (id) {
      Vue.http.get('api/regimento/' + id).then(response => {
        let data = response.body.data
        this.form.titulo = data.titulo
        this.form.descricao = data.descricao
        this.form.artigos = data.artigos
      })
    },
    adicionarArtigo () {
      this.form.artigos.push({
        id: null,
        texto: ''
      })
    },
    removerArtigo (key) {
      this.form.artigos.splice(key, 1)
    },
    salvar () {
      let form = this.$v.form
      let data = {
        titulo: form.titulo.$model,
        descricao: form.descricao.$model,
        artigos: this.form.artigos
      }
      this.loading = true

      Vue.http.post('api/regimento', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({path: '/'})
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/regimento/RegimentoVisualizar.vue